import React from 'react';
import {FormattedMessage} from 'react-intl';
import {bool, func, string} from 'prop-types';
import BasicModal from 'components/common/BasicModal';
import {EmptyFunc} from 'utils/DBUtils';

const RepairProfileModal = props => (
  <BasicModal
    dimmer='inverted'
    header={<FormattedMessage id='userManagement.userDetail.modals.repairProfile.header' values={{email: props.email}} />}
    specialType='primary-modal db-create-break-modal fadeInUp animResponse'
    modalSize='small'
    actions={[
      {
        label: <FormattedMessage id='userManagement.userDetail.modals.repairProfile.cancel' />,
        action: props.cancel,
        isDisabled: props.repairing,
        displayType: 'menu-item'
      },
      {
        label: <FormattedMessage id='userManagement.userDetail.modals.repairProfile.submit' />,
        action: props.confirm,
        loading: props.repairing,
        displayType: 'button',
        primaryCheck: true
      }
    ]}
    open={props.modalOpen}
    onClose={props.repairing ? EmptyFunc : props.cancel}>
    <FormattedMessage
      id='userManagement.userDetail.modals.repairProfile.message'
      values={{email: props.email}} />
  </BasicModal>
);

RepairProfileModal.propTypes = {
  repairing: bool,
  modalOpen: bool,
  confirm: func.isRequired,
  cancel: func.isRequired,
  email: string
};

export default RepairProfileModal;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/RepairProfileModal/RepairProfileModal.jsx